import { Injectable } from '@angular/core';
import { Notify } from 'notiflix/build/notiflix-notify-aio';

@Injectable()
export class ToastService {

  constructor(
  ) {
    Notify.init({
      pauseOnHover: false
    });
  }

  async error(message: string) {
    Notify.failure(message, {
      position: 'right-top',
      borderRadius: '4px',
      timeout: 3000
    });
  }

  async success(message: string) {
    Notify.success(message, {
      position: 'right-top',
      borderRadius: '4px',
      timeout: 3000
    });
  }

  async primary(message: string) {
    Notify.info(message, {
      position: 'right-top',
      borderRadius: '4px',
      timeout: 3000
    });
  }

}
